<template>
<div>
  <div class="sub_visual_wrap">
        <div class="sub_visual_box container">
            <div class="page_nav">
                <ul>
                    <li><router-link to="/main" @click.native="$store.commit('setActive','')">{{$t('common.home')}}</router-link></li>
                    <li><a href="#">{{$t('common.signup')}}</a></li>
                </ul>
            </div>	
            <h2>{{$t('signup.signup')}}</h2>
        </div>
    </div>
<section class="sub_contents_wrap container">
 
<component :is="component" v-if="componentName == 'SignupStep1'" @goBefore="goBefore" @goNextStep="goNextStep" :status="`RRV`" />
<component :is="component" v-if="componentName == 'SignupStep2'" @goBefore="goBefore" @goNextStep="goNextStep" :status="`RRV`" />
<component :is="component" v-if="componentName == 'SignupStep3'" @goNextStep="goNextStep" :status="`RRV`" />


</section>
</div>    
</template>

<script>

export default {
    data() {
		return { 
			component: null, 
			componentName: null,
			nav : 'Notice',
			};
	},
    methods:{
        loadComponent(type) {
            this.componentName = type;
            this.component = () => import(`@/components/account/` + this.componentName);
        },
        goNextStep(type){
            this.componentName = type.component;
            this.component = () => import(`@/components/account/` + this.componentName);
        },
        goBefore(type){
            this.componentName = type.component;
            this.component = () => import(`@/components/account/` + this.componentName);
        }
    },
    mounted() {
        this.loadComponent('SignupStep1');
	},  
};
</script>

<style>

</style>
